
export const RouteSharedState = {
  routeSharedFromCase: null,
  routeSharedFromRecord: null,
}

export const RouteSharedActions = {
  updateRSState: ({ commit }, path) => {
    if (!path) return

    switch (path.name) {
      case 'case':
        commit('setRSFromCase', true)
        commit('setRSFromRecord', null)
        break
      case 'record':
        commit('setRSFromCase', null)
        commit('setRSFromRecord', true)
        break
      default:
        commit('setRSFromCase', null)
        commit('setRSFromRecord', null)
        break
    }
  },
}

export const RouteSharedMutations = {
  setRSFromCase: (state, payload) => { state.routeSharedFromCase = payload },
  setRSFromRecord: (state, payload) => { state.routeSharedFromRecord = payload },
}

export const RouteSharedGetters = {
  isRSFromCase: state => state.routeSharedFromCase,
  isRSFromRecord: state => state.routeSharedFromRecord,
}
